module.exports = __webpack_public_path__ + "static/media/in.34594e68.svg";